import { Box, CircularProgress, Typography } from "@mui/material";

export default function AppLoading() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      width="100vw"
      position="fixed"
      top={0}
      left={0}
      backgroundColor="background.default"
      zIndex={9999}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" sx={{ mt: 2, color: "text.secondary" }}>
        Loading...
      </Typography>
    </Box>
  );
}
